import { ReactElement, SVGProps } from 'react'
export const SvgInstagram = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#instagram_svg__a)">
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
        fill="url(#instagram_svg__b)"
      />
      <path
        d="M24.505 11.806a4.505 4.505 0 0 0-1.372-2.886 4.712 4.712 0 0 0-3.107-1.295 61.63 61.63 0 0 0-8.376.142 4.285 4.285 0 0 0-3.676 3.276 46.757 46.757 0 0 0-.078 9.514 4.272 4.272 0 0 0 3.405 3.702c3.117.292 6.255.292 9.372 0a4.272 4.272 0 0 0 3.715-3.378c.3-3.016.34-6.052.117-9.075Zm-1.553 8.48a2.874 2.874 0 0 1-2.706 2.588c-2.91.215-5.834.175-8.738-.116a2.783 2.783 0 0 1-2.11-2.434 57.139 57.139 0 0 1 0-8.557 2.874 2.874 0 0 1 2.68-2.589 59.87 59.87 0 0 1 8.35 0 2.873 2.873 0 0 1 2.588 2.706c.17 2.799.148 5.606-.064 8.401Zm-6.784-8.635a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm0 7.146a2.809 2.809 0 1 1 2.835-2.784 2.807 2.807 0 0 1-2.86 2.822l.025-.038Zm5.567-7.314a1.023 1.023 0 1 1-1.023-.984 1.022 1.022 0 0 1 .997 1.022l.026-.038Z"
        fill="#fff"
      />
      <path
        d="M24.505 11.806a4.505 4.505 0 0 0-1.372-2.886 4.712 4.712 0 0 0-3.107-1.295 61.63 61.63 0 0 0-8.376.142 4.285 4.285 0 0 0-3.676 3.276 46.757 46.757 0 0 0-.078 9.514 4.272 4.272 0 0 0 3.405 3.702c3.117.292 6.255.292 9.372 0a4.272 4.272 0 0 0 3.715-3.378c.3-3.016.34-6.052.117-9.075Zm-1.553 8.48a2.874 2.874 0 0 1-2.706 2.588c-2.91.215-5.834.175-8.738-.116a2.783 2.783 0 0 1-2.11-2.434 57.139 57.139 0 0 1 0-8.557 2.874 2.874 0 0 1 2.68-2.589 59.87 59.87 0 0 1 8.35 0 2.873 2.873 0 0 1 2.588 2.706c.17 2.799.148 5.606-.064 8.401Zm-6.784-8.635a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm0 7.146a2.809 2.809 0 1 1 2.835-2.784 2.807 2.807 0 0 1-2.86 2.822l.025-.038Zm5.567-7.314a1.023 1.023 0 1 1-1.023-.984 1.022 1.022 0 0 1 .997 1.022l.026-.038Z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        id="instagram_svg__b"
        x1={31.612}
        y1={-3.223}
        x2={5.994}
        y2={28.337}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.01} stopColor="#3542E0" />
        <stop offset={0.17} stopColor="#3841DF" />
        <stop offset={0.27} stopColor="#403FDA" />
        <stop offset={0.36} stopColor="#4E3CD2" />
        <stop offset={0.43} stopColor="#6337C7" />
        <stop offset={0.5} stopColor="#7D31B9" />
        <stop offset={0.56} stopColor="#9E2AA8" />
        <stop offset={0.62} stopColor="#C82091" />
        <stop offset={0.76} stopColor="#F62B37" />
        <stop offset={1} stopColor="#FFC658" />
      </linearGradient>
      <clipPath id="instagram_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)
